var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"landing-page"},[_c('StandappHeaderV2Component'),_vm._t("default"),(['shome'].includes(_vm.$route.name))?_c('AuthFooterV2Component'):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }